import type * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/shared/lib/cn'

const alertVariants = cva(
  'relative w-full rounded-lg border px-4 py-3 [font-size:var(--type-supporting-font-size)] [font-weight:var(--type-supporting-font-weight)] [line-height:var(--type-supporting-line-height)] grid has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr] grid-cols-[0_1fr] has-[>svg]:gap-x-3 gap-y-0.5 items-start [&>svg]:size-4 [&>svg]:translate-y-0.5 [&>svg]:text-current',
  {
    variants: {
      variant: {
        default: 'bg-card text-card-foreground',
        info: 'border-transparent bg-info-soft text-info-soft-foreground',
        success: 'border-transparent bg-success-soft text-success-soft-foreground',
        warning: 'border-transparent bg-warning-soft text-warning-soft-foreground',
        destructive: 'border-transparent bg-destructive-soft text-destructive-soft-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

function Alert({ className, variant, ...props }: React.ComponentProps<'div'> & VariantProps<typeof alertVariants>) {
  return <div data-slot="alert" role="alert" className={cn(alertVariants({ variant }), className)} {...props} />
}

function AlertTitle({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="alert-title"
      className={cn(
        'col-start-2 line-clamp-1 min-h-4 [font-size:var(--type-label-font-size)] [font-weight:var(--type-label-font-weight)] [line-height:var(--type-label-line-height)] tracking-tight',
        className
      )}
      {...props}
    />
  )
}

function AlertDescription({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="alert-description"
      className={cn(
        'col-start-2 grid justify-items-start gap-1 [font-size:var(--type-supporting-font-size)] [font-weight:var(--type-supporting-font-weight)] [line-height:var(--type-supporting-line-height)]',
        className
      )}
      {...props}
    />
  )
}

export { Alert, AlertTitle, AlertDescription }
